import { motion, useReducedMotion } from 'framer-motion';

const PARTICLE_COUNT = 14;
const EASE: [number, number, number, number] = [0.22, 1, 0.36, 1];

export default function CelebrationBurst() {
  const reducedMotion = useReducedMotion();
  if (reducedMotion) return null;

  return (
    <span className="celebration-burst" aria-hidden>
      {Array.from({ length: PARTICLE_COUNT }, (_, i) => {
        const angle = (i * (360 / PARTICLE_COUNT) + (Math.random() * 20 - 10)) * (Math.PI / 180);
        const dist = 30 + Math.random() * 30;
        return (
          <motion.span
            key={i}
            className="celebration-particle"
            initial={{ x: 0, y: 0, opacity: 1, scale: 1 }}
            animate={{
              x: Math.cos(angle) * dist,
              y: Math.sin(angle) * dist,
              opacity: 0,
              scale: 0.3,
            }}
            transition={{ duration: 0.7, ease: EASE }}
            style={{
              background: i % 3 === 0 ? 'var(--accent-dim)' : 'var(--accent)',
            }}
          />
        );
      })}
    </span>
  );
}
